/**
 * 
 * @param {Number} number 
 */
function convertToSimply(number){
    let numberStr = number.toString()

    if(number >= 1000 && number < 10000){
        var finalStr = ""
        let selectFirstNum = numberStr.slice(0, 1)
        let secondNum = numberStr.slice(1, 2)
        finalStr += selectFirstNum
        if(secondNum !== "0"){
            finalStr += "." + secondNum
        }
        finalStr += "K"
        console.log(finalStr)
        return finalStr
    }
    else if(number >= 10000 && number < 100000){
        var finalStr = ""
        let selectNum = numberStr.slice(0, 2)
        finalStr += selectNum + "K"
        return finalStr
    }
    else if(number >= 100000 && number < 1000000){
        var finalStr = ""
        let selectNum = numberStr.slice(0, 3)
        finalStr += selectNum + "K"
        return finalStr
    }
    else{
        return numberStr
    }
}

export { convertToSimply }